'use client';

import type { NolNotificationListDataType } from '@weberus/shared-types';
import type { HomeLogPageNameValue } from '@/app/(pages)/sub-home/[category]/constants';
import { FC, useEffect } from 'react';
import { clientLogStandardized } from '@weberus/client-tracker';
import { useInView } from 'react-intersection-observer';
import NolNotificationListItem from '@/app/_components/widgets/nol-notification-list/ui/nol-notification-list-item';

export interface NolNotificationListProps {
  pageNameLog: HomeLogPageNameValue;
  data?: NolNotificationListDataType;
}

/**
 * 위젯_라이브 공지
 *
 * @see {@link https://www.figma.com/design/jImqz2em0kItEVBBffwz03/%5BGUIDE%5D-%ED%99%88%2F%EC%84%9C%EB%B8%8C%ED%99%88?node-id=4868-96535&t=kA3jRUtpOvWT1fUK-1}
 */

export const NolNotificationList: FC<NolNotificationListProps> = ({ pageNameLog, data }: NolNotificationListProps) => {
  const logMeta = data?.logMeta || {};
  const { ref, inView } = useInView({ triggerOnce: true });

  useEffect(() => {
    if (inView) {
      clientLogStandardized('impression', pageNameLog, { objectType: 'noticeBanner', ...logMeta });
    }
  }, [inView]);

  return (
    <section ref={ref} className="w-full px-16 py-16 pc:max-w-pc-size pc:px-24 pc:py-40">
      <div className="flex h-50 items-center pc:h-80">
        <h2 className="typography-subtitle-18-bold pc:typography-headline-24-bold">{data?.header?.title}</h2>
      </div>
      <ul className="flex flex-col pc:max-h-[590px] pc:flex-wrap pc:[&>li:nth-child(-n+10)]:mr-20">
        {data?.items?.map((item, index) => (
          <NolNotificationListItem key={index} widgetLogMeta={logMeta} pageNameLog={pageNameLog} data={item} />
        ))}
      </ul>
    </section>
  );
};
